const optionalBooleanMapper = new Map([
  ['undefined', undefined],
  ['true', true],
  ['false', false],
  ['1', true],
  ['0', false],
]);

export const parseBoolean = (value: string | number | boolean | undefined) => {
  if (value === undefined || value === null) {
    return undefined;
  }

  const mappedValue = optionalBooleanMapper.get(
    value?.toString()?.toLowerCase(),
  );

  if (mappedValue !== undefined) {
    return mappedValue;
  }
};
